
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-value/[[...subpages]]",
      function () {
        return require("private-next-pages/get-value/[[...subpages]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-value/[[...subpages]]"])
      });
    }
  